import React from "react";
import { PromptEditorProps } from "../../../Interfaces/PromptPlayground.interfaces";
import { TextFieldWithActions } from "../TextFieldWithActions";
import { playgroundClassNames as classNames, playgroundStyles as styles } from "../../../Styles";

export const PromptEditor: React.FC<PromptEditorProps> = ({ prompt, onChange, onCopy }) => {
  return (
    <TextFieldWithActions
      actionButtons={[
        {
          iconName: "Copy",
          title: "Copy prompt to clipboard",
          onClick: () => onCopy(prompt),
          disabled: !prompt.trim()
        }
      ]}
      actionButtonClassName={classNames.copyIconStyle}
      label="Prompt"
      containerClassName={classNames.textFieldContainerStyle}
      onChange={onChange}
      rows={20}
      textFieldStyles={styles.textFieldStyles}
      value={prompt}
    />
  );
};
